import type { SumTypesByCategory } from "./types";
import type { DeviceCategory } from "../deviceCategories";

export const sumTypesByCategory: SumTypesByCategory = (countsByBoard) => {
  const sum: ReturnType<SumTypesByCategory> = {};
  Object.values(countsByBoard).forEach((byCategory) => {
    Object.entries(byCategory).forEach(([category, types]) => {
      const into = (sum[category as DeviceCategory] ??= {});
      Object.entries(types ?? {}).forEach(([type, count]) => {
        into[type] = (into[type] ?? 0) + count;
      });
    });
  });
  return sum;
};
